export default __webpack_public_path__ + "static/pic4-bd94dd4b31b03051ec7486242152c5b7.webp";